(function () {
	const calculator = {
		form: document.getElementById('cnfsd-cng'),
		results: document.querySelector('.cng-results'),
		backButton: document.querySelector('.arrow-link'),
		title: document.querySelector('h2'),
		calculatorProgressState: 0,
		submitButton: null,
		fieldgroups: null,
		restartButton: null,
		jsonData: null,
		init: () => {
			calculator.fieldgroups = calculator.form.querySelectorAll('fieldset');
			calculator.submitButton = calculator.form.querySelector('button');
			calculator.restartButton = calculator.results.querySelector('button');
			calculator.results.classList.add('cng-hidden');
			calculator.backButton.classList.add('cng-hidden');
			calculator.getCarNames();
			calculator.changeFieldSet();
			calculator.handleProgressbar(); //WHEN CONTINUE BUTTON CLICKED

			calculator.submitButton.addEventListener('click', e => {
				e.preventDefault();
				calculator.checkUserInput();
				calculator.handleProgressbar();
			}); //RESET WIDGET

			calculator.restartButton.addEventListener('click', e => {
				calculator.calculatorProgressState = 0;
				calculator.changeFieldSet();
				calculator.toggleResults();
				calculator.submitButton.classList.remove('cng-hidden');
				calculator.title.classList.remove('cng-hidden');
				calculator.handleProgressbar();
			}); //WHEN BACK BUTTON CLICKED

			calculator.backButton.addEventListener('click', e => {
				e.preventDefault();
				calculator.calculatorProgressState -= 1;
				calculator.changeFieldSet();
				calculator.handleProgressbar();

				if (calculator.calculatorProgressState === 0) {
					calculator.backButton.classList.add('cng-hidden');
				}
			});
		},
		//SHOW THE CORRECT FIELDSET BASED ON CURRENT CALCPROGRESSSTATE
		changeFieldSet: () => {
			calculator.fieldgroups.forEach((fieldGroup, i) => {
				if (i !== calculator.calculatorProgressState) {
					fieldGroup.classList.add('cng-hidden');
				} else {
					fieldGroup.classList.remove('cng-hidden');
				}
			});
		},
		checkUserInput: () => {
			const currentFieldShown = calculator.fieldgroups[calculator.calculatorProgressState];
			if (!currentFieldShown.querySelector('input:checked')) return calculator.showUserError(currentFieldShown); //INCREMENT FIELDSET SHOWN

			calculator.calculatorProgressState += 1;
			calculator.changeFieldSet();
			calculator.title.classList.add('cng-hidden'); //SHOW RESULTS IF FORM COMPLETED

			if (calculator.calculatorProgressState > calculator.fieldgroups.length - 1) {
				calculator.submitButton.classList.add('cng-hidden');
				calculator.backButton.classList.add('cng-hidden');
				calculator.toggleResults();
			} else {
				calculator.backButton.classList.remove('cng-hidden');
			}
		},
		toggleResults: () => {
			//SHOW RESULTS
			if (!calculator.results.classList.contains('cng-hidden')) {
				calculator.results.classList.add('cng-hidden');
			} else {
				calculator.results.classList.remove('cng-hidden');
				const licence = document.querySelector('.cng-results__licence');
				const removeId = Math.floor(Math.random() * calculator.jsonData.length);
				licence.innerText = calculator.jsonData[removeId];
			}
		},
		getCarNames: () => {
			const http = new XMLHttpRequest();
			http.open(
				'GET',
				'https://www.confused.com/static/cmsmedia/cms-widgets/redesign/car-name-generator/jsonData/data.json',
				true
			);

			http.onreadystatechange = function () {
				if (http.readyState == 4 && http.status == '200') {
					calculator.jsonData = JSON.parse(http.responseText);
				}
			};

			http.send(null);
		},
		handleProgressbar: () => {
			const progressCurrent = document.getElementById('progress-banner-current');
			const progressTotal = document.getElementById('progress-banner-total');
			const progressbar = document.querySelector('.banner__progress-bar > span');
			const baseBarWidth = ''.concat(100 / parseInt(progressTotal.innerText));
			const activeProgress = calculator.calculatorProgressState + 1; //SET CURRENT PROGRESS NUMBER

			progressCurrent.innerHTML = activeProgress; //SET THE WIDTH OF THE PROGRESS BAR

			progressbar.style.width = ''.concat(baseBarWidth * activeProgress, '%');
		},
		showUserError: fieldGroup => {
			fieldGroup.classList.add('field-group--error');
			const inputs = fieldGroup.querySelectorAll('input');
			calculator.scrollToError(fieldGroup);
			inputs.forEach(input => {
				input.addEventListener('change', calculator.removeError);
			});
		},
		scrollToError: fieldGroup => {
			const error = fieldGroup.querySelector('.error-message');
			error.scrollIntoView({
				behavior: 'smooth',
			});
		},
		removeError: () => {
			const erroredInput = calculator.fieldgroups[calculator.calculatorProgressState];
			erroredInput.classList.remove('field-group--error');
			const inputs = erroredInput.querySelectorAll('input');
			inputs.forEach(input => {
				input.removeEventListener('change', calculator.removeError);
			});
		},
	};
	document.addEventListener('DOMContentLoaded', function () {
		calculator.init();
	});
})();
